import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-end pb-24 md:pb-32 overflow-hidden">
      {/* Background — using the uploaded card images as a collage */}
      <div className="absolute inset-0">
        <img
          src="/images/hero-bright2026.jpg"
          alt="Peaceful nature background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#418b86]/65 via-[#418b86]/35 to-[#418b86]/10"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-black/10"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          {/* Pill Label */}
          <div className="inline-flex items-center gap-2 border border-white/50 text-white/90 text-xs font-medium px-4 py-1.5 rounded-full mb-6 backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-[#7ec8e3] inline-block"></span>
            A Safe Space to Begin
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl font-light text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            You Deserve to Feel<br />
            <span className="font-semibold italic">Understood</span> and Clear.
          </h1>

          {/* Subtext */}
          <p className="text-white/85 text-base md:text-lg font-light mb-10 max-w-lg leading-relaxed">
            Compassionate, personalized counseling to help you navigate life's challenges — at your own pace, in your own way.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#4db8b1] hover:bg-[#418b86] text-white font-medium px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              Get Started
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 border border-white/60 hover:border-white text-white font-medium px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
}
